module.exports = __webpack_public_path__ + "1791188489487/fonts/WorkSans-Regular.e6d353c.woff2";